// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2iqgU","errorLogs":"EditorFooter_errorLogs__1wncT"};